import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-ten',
  templateUrl: './home-ten.component.html',
  styleUrls: ['./home-ten.component.scss']
})
export class HomeTenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
